import { getPpvLeaderIncludedValues } from '../services/getPpvLeaderIncludedValues';

export type DropdownOption = { label: string; value: any };

export async function fetchIncludedValuesByHtz(
  htz: any,
  screenGridId?: number,
): Promise<Array<string | number>> {
  if (typeof screenGridId !== 'number' || !Number.isFinite(screenGridId)) {
    return [];
  }

  const result = await getPpvLeaderIncludedValues({
    htz: String(htz ?? ''),
    screenGridId,
  });

  if (!result || (result as any)?.errors) {
    return [];
  }

  const includedValues = (result as any)?.includedValues;
  return Array.isArray(includedValues) ? includedValues : [];
}

export async function applyInclusionFilterOnce(params: {
  hasFetchedRef: { current: boolean };
  htz: any;
  screenGridId?: number;
  baseOptions: DropdownOption[];
  setValueOptions: (next: DropdownOption[]) => void;
}) {
  const { hasFetchedRef, htz, screenGridId, baseOptions, setValueOptions } = params;

  if (hasFetchedRef.current) return;
  hasFetchedRef.current = true;

  try {
    const includedValues = await fetchIncludedValuesByHtz(htz, screenGridId);
    // Inclusion list is a subset of option labels (matches existing behavior).
    const filtered = includedValues.length
      ? baseOptions.filter((opt) => includedValues.includes(opt.label))
      : baseOptions;

    // If filtering yields empty results, fall back to full option list.
    setValueOptions(filtered.length ? filtered : baseOptions);
  } catch {
    setValueOptions(baseOptions);
  }
}
